declare const jQuery: any;
const $ = jQuery;

import { each, throttle } from "lodash";

let $mainHeader: any = undefined;

export function fillContainer(vw, vh, cw, ch) 
{
	// Shrink
	if (vw > cw || vh > ch) 
	{
		if (vw > cw) {
			vh = Math.ceil((vh / vw) * cw);
			vw = cw;
		}
		if (vh > ch) {
			vw = Math.ceil((vw / vh) * ch);
			vh = ch;
		}
	}
	
	// Grow
	if (vw < cw) 
	{
		vh = Math.ceil((vh / vw) * cw);
		vw = cw;
	}
	
	if (vh < ch) 
	{
		vw = Math.ceil((vw / vh) * ch);
		vh = ch;
	}

	return { w: vw, h: vh };
}

export function mainHeaderIsFixedPosition(): boolean
{
	$mainHeader = $mainHeader || $(".main-header");
	return $mainHeader.css("position") === "fixed";
}

export function getScrollOffsetForHeader(): number
{
	$mainHeader = $mainHeader || $(".main-header");
	if (mainHeaderIsFixedPosition())
	{
		return -$mainHeader.outerHeight();
	}
	return 0;
}

export function getViewportHeight(): void
{
	const id: string = "iw-vph-detect";
	const div = document.getElementById(id);
	const $div = div ? $(div) : $(`<div id="${id}">`).appendTo("body");
	return $div.outerHeight() || document.body.clientHeight;
}

export function findMaxHeight($els, measureScrollHeight: boolean = false): number
{
	let maxHeight: number = 0;
	$els.each(function () {
		const h: number = measureScrollHeight ? this.scrollHeight : $(this).outerHeight();
		if (h && (h > maxHeight))
		{
			maxHeight = h;
		}
	});
	return maxHeight;
}

export function findMaxHeightOfHidden($els, measureScrollHeight: boolean = false): number
{
	const styleCache: any[] = [];
	$els.each(function (index: number) {
		const $el = $(this);
		styleCache[index] = {
			position: $el.css("position"),
			display: $el.css("display"),
			opacity: $el.css("opacity"),
		};
		$el.css({
			position: "absolute",
			display: "block",
			opacity: 0,
		});
	});
	const maxHeight: number = findMaxHeight($els, measureScrollHeight);
	$els.each(function (index: number) {
		const $el = $(this);
		const style = styleCache[index];
		$el.css({
			position: style.position,
			display: style.display,
			opacity: style.opacity,
		});
	});
	return maxHeight;
}

export function padBodyTopForHeader(checkEnabled?: () => boolean): void
{
	const $body = $("body");
	$mainHeader = $mainHeader || $(".main-header");
	const shouldFix = (): boolean => {
		return mainHeaderIsFixedPosition() &&
			$body.hasClass("no-top-banner") &&
			(!checkEnabled || checkEnabled());
	};
	const fix = () => {
		$body.css({ paddingTop: shouldFix() ? $mainHeader.outerHeight() : "" });
	};
	fix();
	$(fix);
	$(window).on("resize load", throttle(fix, 80));
}

// Sets height according to width of element(s)
// Returns a function for forcing refresh
export function keepInProportion($els, width: number, height: number): () => void
{
	if (!width || !height)
	{
		console.error("layout.keepInProportion() error: width/height missing. width =", width, " height =", height);
		return;
	}
	const ratio: number = height / width;
	const calcHeight = (width: number): number => width * ratio;
	const setHeight = ($el): void => $el.css({ height: calcHeight($el.outerWidth()) });
	const setAllHeights = (): void => $els.each(function () {
		setHeight($(this));
	});
	setAllHeights();
	$(window).on("load resize", throttle(setAllHeights, 50, { leading: true }));
	return setAllHeights;
}

// Sets height according to width, in accordance with width & height attributes on element(s)
// Returns a function for forcing refresh
export function keepInProportionUsingAttrs($els): () => void
{
	const fns: (() => void)[] = [];

	$els.each(function () {
		const $el = $(this);
		const width: number = parseInt($el.attr("width"), 10);
		if (!width)
		{
			console.error("layout.keepInProportionUsingAttrs() error: No width attr on element", this);
			return;
		}
		const height: number = parseInt($el.attr("height"), 10);
		if (!height)
		{
			console.error("layout.keepInProportionUsingAttrs() error: No height attr on element", this);
			return;
		}
		fns.push(keepInProportion($el, width, height));
	});

	return (): void => {
		each(fns, fn => fn());
	};
}

export function getOverflowX($el, $container?): number
{
	$container = $container ? $($container) : $(window);
	if ($container.length === 0)
	{
		$container = $(window);
	}
	const right: number = $el.offset().left + $el.outerWidth();
	const containerWidth: number = $container.outerWidth();
	return right - containerWidth;
}

if (!window["iw"])
{
	window["iw"] = {};
}

if (!window["iw"].layout)
{
	window["iw"].layout = {};
}

const globalObj = window["iw"].layout;

globalObj.fillContainer = fillContainer;
globalObj.mainHeaderIsFixedPosition = mainHeaderIsFixedPosition;
globalObj.getScrollOffsetForHeader = getScrollOffsetForHeader;
globalObj.getViewportHeight = getViewportHeight;
globalObj.findMaxHeight = findMaxHeight;
globalObj.findMaxHeightOfHidden = findMaxHeightOfHidden;
globalObj.padBodyTopForHeader = padBodyTopForHeader;
globalObj.keepInProportion = keepInProportion;
globalObj.keepInProportionUsingAttrs = keepInProportionUsingAttrs;
globalObj.getOverflowX = getOverflowX;
